import EditorWorker from 'monaco-editor/esm/vs/editor/editor.worker?worker'
import JsonWorker from 'monaco-editor/esm/vs/language/json/json.worker?worker'
import CssWorker from 'monaco-editor/esm/vs/language/css/css.worker?worker'
import HtmlWorker from 'monaco-editor/esm/vs/language/html/html.worker?worker'
import TypeScriptWorker from 'monaco-editor/esm/vs/language/typescript/ts.worker?worker'

export function getMonacoWorker(_workerId: string, language: string): Worker {
  switch (language) {
    case 'json':
      return new JsonWorker()
    case 'css':
    case 'scss':
    case 'less':
      return new CssWorker()
    case 'html':
    case 'handlebars':
    case 'razor':
      return new HtmlWorker()
    case 'typescript':
    case 'javascript':
      return new TypeScriptWorker()
    default:
      return new EditorWorker()
  }
}

// Local ESM also needs local workers. Without this, JSON/notebook diagnostics
// fail at runtime even though the main editor renders and SQL-only tests pass.
self.MonacoEnvironment = { ...self.MonacoEnvironment, getWorker: getMonacoWorker }
